export type FortuneWheelRequest = {
  host: string;
};

export type FortuneWheelResponse = {
  statusCode: number;
  id: number;
  createdAt: string;
};

export type FortuneWheelListResponse = {
  sections: FortuneWheelSectionItem[];
};

export type FortuneWheelSectionItem = {
  id: string;
  rewardId: string;
  label: string;
  description: string;
  iconUrl: string;
};

export enum FORTUNE_WHEEL_STEPS {
  INIT,
  SPIN,
  SUCCESS,
  FAILED,
}

export type FortuneWheelSpinWin = { section: FortuneWheelSectionItem };

export type FortuneWheelSpinCooldown = {
  availability: { isAvailable: boolean; nextAvailableAt?: string };
};

export type FortuneWheelSpinResponse =
  | FortuneWheelSpinWin
  | FortuneWheelSpinCooldown;

export type FortuneWheelAvailabilityResponse = {
  isAvailable: boolean;
  nextAvailableAt?: string;
};
